import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function EsqueciSenha() {
  const navigate = useNavigate();
  const [chapa, setChapa] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [etapa, setEtapa] = useState(1);
  
  // Inputs do usuário
  const [cpfDigitado, setCpfDigitado] = useState("");
  const [nascimentoDigitado, setNascimentoDigitado] = useState("");
  const [emailDigitado, setEmailDigitado] = useState("");
  const [novaSenha, setNovaSenha] = useState("");

  // Funções de máscara visual (Ex: 055.***.***-50 e fa***@flo***.com)
  const formatarCPFParcial = (cpf) => {
    return `${cpf.substring(0, 3)}.***.***-${cpf.substring(9, 11)}`;
  };

  const formatarEmailParcial = (email) => {
    const [user, domain] = email.split("@");
    return `${user.substring(0, 3)}*****@${domain.substring(0, 4)}*****`;
  };

  const buscarPorChapa = async () => {
    if (!chapa) return Swal.fire("Erro", "Informe a matrícula", "error");
    try {
      const { data } = await api.get(`/usuario/dados/${chapa}`);
      if (data && data.length > 0) {
        setUsuario(data[0]);
        setEtapa(2);
      } else {
        Swal.fire("Erro", "Matrícula não encontrada", "error");
      }
    } catch (error) {
      Swal.fire("Erro", "Falha ao buscar dados", "error");
    }
  };

  const validarDados = () => {
    const cpfLimpo = cpfDigitado.replace(/\D/g, "");
    const nascFormatado = new Date(usuario.dtnascimento).toISOString().substring(0, 10);

    if (cpfLimpo !== usuario.cpf) {
      return Swal.fire("Erro", "CPF não confere", "error");
    }
    if (nascimentoDigitado !== nascFormatado) {
      return Swal.fire("Erro", "Data de nascimento não confere", "error");
    }
    if (emailDigitado.trim().toLowerCase() !== usuario.email.trim().toLowerCase()) {
      return Swal.fire("Erro", "E-mail não confere", "error");
    }

    setEtapa(3); // Vai para troca de senha
  };

  const salvarNovaSenha = async () => {
    try {
      const response = await api.post(`/usuario/${usuario.chapa}`, { senha: novaSenha });
      if (response.status === 201 || response.status === 200) {
        Swal.fire("Sucesso", "Senha alterada com sucesso!", "success");
        navigate("/arbor/login");
      }
    } catch (error) {
      Swal.fire("Erro", "Não foi possível alterar a senha", "error");
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Menu modulo="ALTERAR SENHA" />
      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
        <div className="container p-4 shadow-sm bg-light rounded" style={{ maxWidth: 500 }}>
          <h4 className="mb-4 text-center">Recuperar Acesso</h4>

          {etapa === 1 && (
            <>
              <label>Informe sua Matrícula:</label>
              <input type="text" className="form-control" value={chapa} onChange={(e) => setChapa(e.target.value)} />
              <button className="btn btn-primary mt-3 w-100" onClick={buscarPorChapa}>Continuar</button>
            </>
          )}

          {etapa === 2 && (
            <>
              <p className="text-muted small text-center">Confirme os dados para sua segurança</p>
              
              <label>CPF (Inicia com {formatarCPFParcial(usuario.cpf)}):</label>
              <InputMask mask="999.999.999-99" className="form-control" onChange={(e) => setCpfDigitado(e.target.value)} />

              <label className="mt-2">Data de Nascimento:</label>
              <input type="date" className="form-control" onChange={(e) => setNascimentoDigitado(e.target.value)} />

              <label className="mt-2">E-mail (Dica: {formatarEmailParcial(usuario.email)}):</label>
              <input type="email" className="form-control" onChange={(e) => setEmailDigitado(e.target.value)} />

              <button className="btn btn-success mt-4 w-100" onClick={validarDados}>Validar Dados</button>
            </>
          )}

          {etapa === 3 && (
            <>
              <label>Nova Senha:</label>
              <input type="password" title="Mínimo 6 caracteres" className="form-control" onChange={(e) => setNovaSenha(e.target.value)} />
              <button className="btn btn-primary mt-3 w-100" onClick={salvarNovaSenha} disabled={novaSenha.length < 6}>
                Atualizar Senha
              </button>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EsqueciSenha;